import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class VtService {
    constructor(private dataTask: DataTaskService) {}

    public getEdit(params: VtKeyParams): Promise<VtPage[]> { return this.dataTask.Post(3789, params); }
    public saveObj(page: VtPage): Promise<VtResponse[]> { return this.dataTask.Post(3790, page); }
    public translateAndPublish(page: VtPage): Promise<VtResponse[]> { return this.dataTask.Post(3799, page); }
    public listLanguages(): Promise<Item[]> { return this.dataTask.Post(57); }
}

export interface VtKeyParams { vt_keyno: string; }
export interface VtPage extends VtKeyParams {
    filename: string; reg_datetime: string; source_language_id: string; vtlink_p2_webpage_keyno: string;
    is_active: string; only_insoft: string; dev: string; video_title: string; video_description: string;
    full_url: string; destin_language_id: string; [key: string]: string;
}
export interface VtResponse { errorcode: string; errormessage: string; }
